module.exports = __webpack_public_path__ + "img/device_not_found_icon.432a2ca6.svg";